<template>
 
<div id="root">

<v-card>
 <v-navigation-drawer
   
   v-model="drawer"
     app dark
      :mini-variant.sync="mini"
      permanent
    >
      <template v-slot:prepend>
        <v-list-item>
        <v-list-item-avatar>
       <!--   <v-img src="https://randomuser.me/api/portraits/men/85.jpg"></v-img>   -->
              <v-img src="nextGen_logo-simple.png"></v-img>
        </v-list-item-avatar>

        <v-list-item-title v-if="!$keycloak.authenticated">
          <v-btn @click="$keycloak.loginFn" text small >
            <v-icon left>mdi-login</v-icon> Login
          </v-btn>
        </v-list-item-title>
<!--
       <v-list-item v-if="$keycloak.authenticated">
        <v-avatar size="30" color="">
         <span class="white--text">CJ</span>
        </v-avatar>
         </v-list-item>
  --> 
        <v-list-item-content v-if="$keycloak.authenticated">
            <v-list-item-title class="ml-2">{{$keycloak.userName}}</v-list-item-title>
            <v-list-item-subtitle>
               <v-btn @click="$keycloak.logoutFn" text small  >
                <v-icon left>mdi-logout</v-icon> Logout
                 </v-btn>

            </v-list-item-subtitle>
          </v-list-item-content>

        <v-btn
          icon
          @click.stop="none" 
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </v-list-item>
      </template>

      <v-divider></v-divider>

   <v-treeview
    
    shaped
    hoverable
    activatable
    :active.sync="active_node"
    :open.sync="open_nodes" 
    :items="items"
    open-on-click
    @update:active="tree_view_update"
    :return-object="true">

<template v-slot:prepend="{ item } "  >
         <v-icon
          v-if="item.id===1"
          v-text="`mdi-home-variant`">
           </v-icon>
          <v-icon
          v-if="item.id===11"
          v-text="`mdi-key`">
           </v-icon>
          <v-icon
          v-else-if="item.children"
          v-text="`mdi-folder-network`">
           </v-icon>


         
        </template>
       

  </v-treeview>

   

      
    </v-navigation-drawer>
    </v-card>

   
  
    <div id="fg" v-bind:class="{ small_left_margin: mini, big_left_margin: !mini }">
      <div class="mt-2 clock legend leaflet-control">
        <h4>Entities</h4>

<img src="CreateNewProject2.svg" height='30' width='40'><span>Project</span><br> <br>
<img src="PointofInterest2.svg" height='30' width='40'><span>PoI</span><br> <br>
<img src="QuizGameIcon2.svg" height='30' width='40'><span>PoI with Quiz</span><br>



  

      <!--
   <v-breadcrumbs :items="b_items" large class="white--text clock leaflet-control">
      <template v-slot:item="props">
      <v-breadcrumbs-item
        :href="props.item.href"
        :class="[props.item.disabled && 'disabled']"
      >
      <span class="red--text">
        {{ props.item.text }}
        </span>
      </v-breadcrumbs-item>
      
    </template>




   </v-breadcrumbs>
   --> </div>
   </div>


  <!--
  <v-card
      class="d-flex justify-center"
      color="grey lighten-2"
      flat
      tile
    >
  <div class="clock leaflet-control">
 <v-btn color="#305728" class="mt-3 white--text" >  Add to map  
 <v-icon right white>mdi-plus-circle</v-icon>
 </v-btn>

</div>
</v-card>
-->
   

    
     

   
 <router-view></router-view>
  <!--  sosto
  <v-card 
      class="d-flex justify-center"
      color="grey lighten-2"
      flat
      tile
    >
  <div class="clock leaflet-control">




 <v-btn id="search_element" color="#305728" class="mb-24 white--text" >  Add to map  
 <v-icon right white>mdi-plus-circle</v-icon>
 </v-btn>

</div>
</v-card>
-->









  
<div id="map" v-bind:class="{crosshair_cursor: pick_a_point, simple_cursor: !pick_a_point }" v-bind:style="{   height: window.height + 'px'}" >
  
  


  </div>

  
 
  
      




 </div>
  
</template>

<script>
//import axios from 'axios';
import 'leaflet';
import 'leaflet-draw';
import { ATTRIBUTION, MAP_URL, APIS_BASE_URL } from '../constants';
import router from '../router';
import axios from 'axios';
import { componentBus } from '../main';

const L = window.L;


 export default {
  name: 'InteractiveMap',
  props: {
   
    
  },

 

    data: function () {
            return {

        leaflet_dom_util:  null,
        enlarged_pin: null,
        temporary_pin: null,      
        temporary_circle: null,
        
        pois_on_map_list: null,

        relevant_pois: [],

        loading: false,
        my_items: [],
        search: null,
        select: null,
 



          active_node: [],
          open_nodes: [],
          value_list: [],
          pick_a_point: false,
        
          window: {
           width: 0,
           height: 965
    },
 
    

          map: null,
          drawer: true,
          mini: false,
          pins: {},
          circles: null,
          

          custom_marker: L.Marker.extend({
             options: { 
                      uuid: '',
                      type: '',
                      name: ''
                    
                      }
                }),

         project_icon : L.icon({
                          // iconUrl: "project_marker.png",
                           iconUrl: "CreateNewProject2.svg",
                           iconSize: [30, 40],
                           iconAnchor: [20, 40],
                           popupAnchor: [0, -60]
      }),
          project_icon_enlarged : L.icon({
                          // iconUrl: "project_marker.png",
                           iconUrl: "CreateNewProject2.svg",
                           iconSize: [50, 66],
                           iconAnchor: [20, 40],
                           popupAnchor: [0, -60]
      }),
         poi_without_quiz_icon : L.icon({
                          // iconUrl: "poi_without_quiz_marker.png",
                           iconUrl: "PointofInterest2.svg",
                           iconSize: [30, 40],
                           iconAnchor: [20, 40],
                           popupAnchor: [0, -60],
                           
      }),
      poi_without_quiz_icon_enlarged : L.icon({
                          // iconUrl: "poi_without_quiz_marker.png",
                           iconUrl: "PointofInterest2.svg",
                           iconSize: [50, 66],
                           iconAnchor: [20, 40],
                           popupAnchor: [0, -60],
                           
      }),
         poi_with_quiz_icon : L.icon({
                           //iconUrl: "poi_with_quiz_marker.png",
                           iconUrl: "QuizGameIcon2.svg",
                           iconSize: [30, 40],
                           iconAnchor: [20, 40],
                           popupAnchor: [0, -60]
      }),
      poi_with_quiz_icon_enlarged : L.icon({
                           //iconUrl: "poi_with_quiz_marker.png",
                           iconUrl: "QuizGameIcon2.svg",
                           iconSize: [50, 66],
                           iconAnchor: [20, 40],
                           popupAnchor: [0, -60]
      }),
      temporary_project_icon:  L.icon({
                          // iconUrl: "project_marker.png",
                           iconUrl: "CreateNewProject2.svg",
                           iconSize: [30, 40],
                           iconAnchor: [20, 40],
                           popupAnchor: [0, -60],
                           opacity: 0.4,
                           className: 'temporary_pin'
      }),
      temporary_poi_icon:  L.icon({
                          // iconUrl: "project_marker.png",
                           iconUrl: "PointofInterest2.svg",
                           iconSize: [30, 40],
                           iconAnchor: [20, 40],
                           popupAnchor: [0, -60],
                           className: 'temporary_pin'
      }),





        items: [
         {

          id: 1,
          name: 'Home'
        
        },
        {
          id: 2,
          name: 'Project Manager',
          children: [
            {
              id: 3,
              name: 'Create Project',
            
              
            },
            {
              id: 4,
              name: 'Edit Project',
            
             
            },

             {
          id: 5,
          name: 'PoI Manager',
          children: [
            {
              id: 6,
              name: 'Create PoI',
              
            },
            {
              id: 7,
              name: 'Edit PoI',
             
            },


            
          ]



        },

          {
          id: 8,
          name: 'Quiz Manager',
          children: [
            {
              id: 9,
              name: 'Create Quiz',
              
            },
            {
              id: 10,
              name: 'Edit Quiz',
             
            },


            
          ]}
          ]}
        ],

          

       
            








        b_items: [
        {
          text: 'Dashboard',
          disabled: false,
          href: 'breadcrumbs_dashboard',
        },
        {
          text: 'Link 1',
          disabled: false,
          href: 'breadcrumbs_link_1',
        },
        {
          text: 'Link 2',
          disabled: true,
          href: 'breadcrumbs_link_2',
        },
      ],
               
     poi_title: null,
     poi_longitude: null,
     poi_latitude: null,
     poi_description: null,             
     poi_multimedia_type: null,
     poi_video_link: null,
     poi_relevant_project: null,
     poi_uuid: null,
	 poi_has_quiz: null,
	 poi_activation_range: null
                

               
            };

},

 watch: {
      search (val) {
        val && val !== this.select && this.querySelections(val)
      }
 },

computed: {
  classObject: function () {
    return {
     
     
      'height':  this.window.height
    }
  }
},





methods: {



      fetch_quiz_details_and_render_on_map(quiz_uuid)
      {   
        var get_quiz_url=APIS_BASE_URL+"/quiz/"+quiz_uuid+"/";
        var get_quiz_url_encoded= encodeURI(get_quiz_url);
   
        axios.get(get_quiz_url_encoded)
                    .then(response => {
                    this.fetch_poi_details_and_render_on_map(response.data.relevant_poi);                  
      
                    })
                    .catch(error => console.log(error));

                    
      },

      fetch_poi_details_and_render_on_map(poi_uuid)
      {   
        var get_poi_url=APIS_BASE_URL+"/pois/"+poi_uuid+"/";
        var get_poi_url_encoded= encodeURI(get_poi_url);
   
        axios.get(get_poi_url_encoded)
                    .then(response => {
                   

                    this.render_on_map_relevant_pois_and_project_range(response.data.relevant_project).then(() => {
                    // here to enlarge the pin
                    // centerMarker.setIcon(bigIcon);
                    //this.poi_with_quiz_icon
                    //poi_without_quiz_icon_enlarged
                    if (this.enlarged_pin!=null) 
                    {
                    this.leaflet_dom_util.removeClass(  this.enlarged_pin['pin']._icon, "blinking"    );
                     //* if(this.enlarged_pin['type']=='project') this.enlarged_pin["pin"].setIcon(this.project_icon);
                        //* else if(this.enlarged_pin['type']=='poi_without_quiz') this.enlarged_pin['pin'].setIcon(this.poi_without_quiz_icon);
                        //* else if(this.enlarged_pin['type']=='poi_with_quiz') this.enlarged_pin['pin'].setIcon(this.poi_with_quiz_icon);
                    }
                    this.enlarged_pin={};
                    response.data.relevant_quiz.length>0 ? this.enlarged_pin['type']='poi_with_quiz' : this.enlarged_pin['type']='poi_without_quiz';
                    this.enlarged_pin['pin']=this.pois_on_map_list['pois'][poi_uuid];
                    //* response.data.relevant_quiz.length>0 ? this.pois_on_map_list['pois'][poi_uuid].setIcon(this.poi_with_quiz_icon_enlarged) : this.pois_on_map_list['pois'][poi_uuid].setIcon(this.poi_without_quiz_icon_enlarged)
                    this.leaflet_dom_util.addClass(  this.pois_on_map_list['pois'][poi_uuid]._icon, "blinking"    );
                    //this.pois_on_map_list['pois'][poi_uuid].setIcon();
                    //alert("hello");
                    //console.log("pin icon"+this.pois_on_map_list['pois'][poi_uuid].options.icon.iconUrl);
                    this.map.setView(this.pois_on_map_list['pois'][poi_uuid].getLatLng(),17); 
               
              })
               .catch(err => console.log("Axios err: ", err))
                   
                   
                 
              
                        
                    })
                    .catch(error => console.log(error));

                    
      },

      delete_all_pois_and_circles()
      {
		if(this.enlarged_pin!=null)
        {
        this.leaflet_dom_util.removeClass(   this.enlarged_pin['pin']._icon, "blinking");
		}
		delete this.enlarged_pin;
        this.enlarged_pin=null;
       if ( this.pois_on_map_list !== null   ) 
          { 
          Object.values(this.pois_on_map_list['pois']).forEach(poi_pin => {
          this.map.removeLayer(poi_pin); 
          });  
                          
          }
    
                      
       if ( this.circles !== null) 
          {
           Object.values(this.circles).forEach(circle => {
           this.map.removeLayer(circle); 
          });  
        }

        delete this.pois_on_map_list;
		delete this.circles;
		this.pois_on_map_list=null;
		this.circles=null;

		
		
      },

      render_on_map_relevant_pois_and_project_range(project_uuid)
      {
      if(this.enlarged_pin!=null) 
      { 
        this.leaflet_dom_util.removeClass(this.enlarged_pin['pin']._icon,"blinking");
        console.log("den einai null");
      //*if(this.enlarged_pin['type']=='project') this.enlarged_pin['pin'].setIcon(this.project_icon);
      //*else if(this.enlarged_pin['type']=='poi_without_quiz') this.enlarged_pin['pin'].setIcon(this.poi_without_quiz_icon);
      //*else if(this.enlarged_pin['type']=='poi_with_quiz') this.enlarged_pin['pin'].setIcon(this.poi_with_quiz_icon);
      }
      this.enlarged_pin={};
      this.enlarged_pin['type']='project';
      this.enlarged_pin['pin']=this.pins[project_uuid];
      //* this.pins[project_uuid].setIcon(this.project_icon_enlarged);
      this.leaflet_dom_util.addClass(  this.enlarged_pin['pin']._icon,  "blinking"    );
                     
       this.map.setView(this.pins[project_uuid].getLatLng(),17);  
       console.log(project_uuid);
       
         
       if ( this.pois_on_map_list !== null   ) 
          { 
          Object.values(this.pois_on_map_list['pois']).forEach(poi_pin => {
          this.map.removeLayer(poi_pin); 
          });  
                          
          }
    
                      
       if ( this.circles !== null) 
          {
           Object.values(this.circles).forEach(circle => {
           this.map.removeLayer(circle); 
          });  
                     
		  }
		  
         
          delete this.pois_on_map_list;
		  delete this.circles;
		  this.circles=null;
          this.pois_on_map_list={};
          //this.circles={};  we remove circle from the project
          this.pois_on_map_list["relevant_project_uuid"]=project_uuid;
          this.pois_on_map_list["pois"]= {};
          //var range=null;
          var project_longitude=null;
          var project_latitude=null;
          let get_relevant_pois_url=APIS_BASE_URL+"/projects/"+project_uuid+"/pois";
          let get_relevant_pois_url_encoded= encodeURI(get_relevant_pois_url);
          
   
         return axios.get(get_relevant_pois_url_encoded)
                .then(response => {
                this.relevant_pois=response.data.relevant_pois;
                //range=response.data.range;
                project_longitude= response.data.point.coordinates[0];
                project_latitude= response.data.point.coordinates[1];

                this.relevant_pois
                    .forEach(poi => {
                    let relevant_quiz= poi.relevant_quiz;
                    let poi_icon= relevant_quiz.length > 0 ? this.poi_with_quiz_icon : this.poi_without_quiz_icon;
                    let n=  new this.custom_marker([poi.point.coordinates[1],poi.point.coordinates[0]], {icon: poi_icon, uuid: poi.poi_uuid, type: "poi", name: poi.title}).on('click', (e) => {
					if ( this.circles !== null) 
                    {
                    Object.values(this.circles).forEach(circle => {
                    this.map.removeLayer(circle); 
                    });  
                    }
                    delete this.circles;
					this.circles=null;
					let circle = L.circle([poi.point.coordinates[1], poi.point.coordinates[0]], {
                    color: 'red',
                    fillColor: '#f03',
                    fillOpacity: 0.2,
                    radius: poi.activation_range,
                    interactive: false,
					}).addTo(this.map);
					this.circles={};
                    this.circles[poi.poi_uuid]= circle;



					


                    console.log(e);
                              
                    if(router.currentRoute.path!="/poi_edit") 
                      {
                      router.push({ path: '/poi_edit', query: { poi_uuid: poi.poi_uuid, project_uuid: project_uuid }});
                      console.log("parto malaka: "+ poi.poi_uuid);
                      }
                    else
                      componentBus.$emit('poi_to_edit_uuid', poi.poi_uuid);
                      console.log(e);
                     // here to enlarge the pin
                     if(this.enlarged_pin!=null) 
                      { console.log("mpike mesa");
                       this.leaflet_dom_util.removeClass(  this.enlarged_pin['pin']._icon , "blinking"   );
                        //* (this.enlarged_pin['type']=='project') this.enlarged_pin['pin'].setIcon(this.project_icon);
                        //* else if(this.enlarged_pin['type']=='poi_without_quiz') this.enlarged_pin['pin'].setIcon(this.poi_without_quiz_icon);
                        //* else if(this.enlarged_pin['type']=='poi_with_quiz') this.enlarged_pin['pin'].setIcon(this.poi_with_quiz_icon);
                      }
                      this.enlarged_pin={};
                      relevant_quiz.length>0 ? this.enlarged_pin['type']='poi_with_quiz' : this.enlarged_pin['type']='poi_without_quiz';
                      this.enlarged_pin['pin']=n;
                      //* relevant_quiz.length>0 ? n.setIcon(this.poi_with_quiz_icon_enlarged) : n.setIcon(this.poi_without_quiz_icon_enlarged);
                      this.leaflet_dom_util.addClass(   this.enlarged_pin['pin']._icon, "blinking");              
                     //console.log(e.target.options.icon.options.iconUrl);
                     //alert("hello");
                     //console.log("hello sir");
                     this.map.setView(n.getLatLng(),17); 
                      });  // end of click poi
                           
                    this.pois_on_map_list['pois'][poi.poi_uuid]=n;
                    this.map.addLayer( n );
                     });   // end of pois loop

                     /*   we remove circle from the project
                     let circle = L.circle([project_latitude, project_longitude], {
                     color: 'red',
                     fillColor: '#f03',
                     fillOpacity: 0.2,
                     radius: range,
                     interactive: false,
                    
                     }).addTo(this.map);
                     this.circles[project_uuid]= circle;
                */   
                    })
                    .catch(error => console.log(error));
                          
                    
                         

      },





       project_name_selected: function (event) {
      // `this` inside methods points to the Vue instance
      //alert("malaka");
      console.log("value: "+event.value);
      console.log("text: "+ event.text);
      // `event` is the native DOM event
     
    },

       querySelections (v) {
      this.my_items.splice(0,this.my_items.length);
      var project_search_url=APIS_BASE_URL+"/projects/?title="+v;
      var project_search_url_encoded= encodeURI(project_search_url);
   
      axios.get(project_search_url_encoded)
                    .then(response => {
                    response.data.forEach(val => {

                     let object = {
                       text: val.title,
                       value: val.project_uuid
                        };
      this.my_items.push(object);

                   
                     
              
                    });
                   
                    })
                    .catch(error => console.log(error)); 
        //this.loading = true
        // Simulated ajax query
        //setTimeout(() => {
          //this.my_items = this.states.filter(e => {
            //return (e.text || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1
          //})
          //this.loading = false
       // }, 500)
      },


      update_the_poi_icon_for_removing_quiz(uuid)
      {


       var get_poi_url=APIS_BASE_URL+"/pois/"+uuid+"/";
       var get_poi_url_encoded= encodeURI(get_poi_url);
   
        axios.get(get_poi_url_encoded)
                    .then(response => {
                  
                    let m=  new this.custom_marker([response.data.point.coordinates[1],response.data.point.coordinates[0]], {icon: this.poi_without_quiz_icon, uuid: uuid , type: "poi", name: response.data.title}).on('click', (e) => {
                  //console.log(e.target);
                  //console.log(m);
                  //console.log("aek");    
                  if(this.enlarged_pin!=null)
                  {
                   this.leaflet_dom_util.removeClass(   this.enlarged_pin['pin']._icon, "blinking");
                   //* if(this.enlarged_pin['type']=='project') this.enlarged_pin['pin'].setIcon(this.project_icon);
                   //* else if(this.enlarged_pin['type']=='poi_without_quiz') this.enlarged_pin['pin'].setIcon(this.poi_without_quiz_icon);
                   //* else if(this.enlarged_pin['type']=='poi_with_quiz') this.enlarged_pin['pin'].setIcon(this.poi_with_quiz_icon);
                  }
                  this.enlarged_pin={};
                  this.enlarged_pin['type']='poi_without_quiz';
                  this.enlarged_pin['pin']=e.target;
                  //*e.target.setIcon(this.poi_without_quiz_icon_enlarged);
                  this.leaflet_dom_util.addClass(   this.enlarged_pin['pin']._icon, "blinking");
                  // alert(e.target.options.icon.iconUrl);
                    this.map.setView(e.target.getLatLng(),17);
                         //console.log(e);
                    // it is correct  this.active_node.splice(0,this.active_node.length);
                    //it is correct  this.active_node.push({id: 7});
                                 
                         if(router.currentRoute.path!="/poi_edit")  
                            {
                              router.push({ path: '/poi_edit', query: { poi_uuid: uuid,project_uuid: response.data.relevant_project }});
                             
                             }
                            else
							componentBus.$emit('poi_to_edit_uuid', uuid);
					
					if ( this.circles !== null) 
                    {
                    Object.values(this.circles).forEach(circle => {
                    this.map.removeLayer(circle); 
                    });  
                    }
                    delete this.circles;
					this.circles=null;
					let circle = L.circle([response.data.point.coordinates[1], response.data.point.coordinates[0]], {
                     color: 'red',
                     fillColor: '#f03',
                     fillOpacity: 0.2,
                     radius: response.data.activation_range,
                     interactive: false,
                    
					 }).addTo(this.map);
					 this.circles={};
                     this.circles[uuid]= circle;


                          
                          
                            });

 
                                   
                          

                        // na ksanampei  this.pins.push( m );
                        this.pois_on_map_list['pois'][uuid]=m;
                        //this.pins[uuid]= m;
                        this.map.addLayer( m );
                       



                 
                  //this.active_node.splice(0,this.active_node.length);
                  //this.active_node.push({id: 2});

                 

                  //router.push({ path: '/' }); 

                   
                    
                        
                    })
                    .catch(error => console.log(error)); 

     

      },



     fetch_poi_details(uuid)
      {  
        var get_poi_url=APIS_BASE_URL+"/pois/"+uuid+"/";
        var get_poi_url_encoded= encodeURI(get_poi_url);
   
        axios.get(get_poi_url_encoded)
                    .then(response => {
					this.poi_activation_range= response.data.activation_range;
                    this.poi_title=response.data.title;
                    console.log(response.data.title);
                    this.poi_longitude=response.data.point.coordinates[0];
                    this.poi_latitude=response.data.point.coordinates[1];
                    this.poi_description=response.data.description;
                    this.poi_multimedia_type=response.data.multimedia_type;
                    this.poi_video_link=response.data.video_link;
                    this.poi_relevant_project=response.data.relevant_project;
                    this.poi_uuid=response.data.poi_uuid;
                    this.poi_has_quiz= response.data.relevant_quiz.length > 0;

                   
                    
                        
                    })
                    .catch(error => console.log(error));
      },


     fetch_relevant_pois(project_uuid)
      {  
        var get_relevant_pois_url=APIS_BASE_URL+"/projects/"+project_uuid+"/pois";
        var get_relevant_pois_url_encoded= encodeURI(get_relevant_pois_url);
   
        axios.get(get_relevant_pois_url_encoded)
                    .then(response => {
                    this.relevant_pois=response.data.relevant_pois;
                            
                    })
                    .catch(error => console.log(error));
      },
    
  
     delete_relevant_pois(project_uuid)
     {   
       var get_project_relevant_pois_url=APIS_BASE_URL+"/projects/"+project_uuid+"/pois";
       var get_project_relevant_pois_url_encoded= encodeURI(get_project_relevant_pois_url);
  
   
        axios.get(get_project_relevant_pois_url_encoded)
                    .then(response => {
                    

                    response.data.relevant_pois.forEach(val => {
                    //let poi= this.pins[val.poi_uuid];
                    let poi= this.pois_on_map_list['pois'][val.poi_uuid]
                    this.map.removeLayer(poi);  
                     
              
                    });
                    
                        
                    })
                    .catch(error => console.log(error));
        


     },
//tree_view_update (   (evt) => {
     tree_view_update(evt){


//console.log(this.selected_items);
       
       //console.log(this.active_node);
       //console.log(this.open_nodes);
       //console.log(this.value_list);

    if (typeof evt[0] != 'undefined'  ) {
       
       switch(evt[0].id) {
         case 1:
            this.delete_all_pois_and_circles();
            //if(this.enlarged_pin!=null)
            // {
             // console.log('enlarged pin: '+ this.enlarged_pin['pin']);
              //this.leaflet_dom_util.removeClass(   this.enlarged_pin['pin']._icon, "blinking");
              //*if(this.enlarged_pin['type']=='project') this.enlarged_pin['pin'].setIcon(this.project_icon);
              //*else if(this.enlarged_pin['type']=='poi_without_quiz') this.enlarged_pin['pin'].setIcon(this.poi_without_quiz_icon);
              //*else if(this.enlarged_pin['type']=='poi_with_quiz') this.enlarged_pin['pin'].setIcon(this.poi_with_quiz_icon);
           //  }
           //  this.enlarged_pin=null;
            //console.log(router.currentRoute.path);
            //delete this.pois_on_map_list;
            //delete this.circles;
            //this.pois_on_map_list=null;
            //this.circles=null;
            if(router.currentRoute.path!="/")
               router.push({ path: '/' }); 
            this.map.setView([37.9838, 23.7275], 5);
            //console.log("all projects");
         
            break;
         case 2:
           //console.log(router.currentRoute.path);
            if(router.currentRoute.path!="/")
              router.push({ path: '/' })
            //console.log("my projects");
            break;
         case 3:
           //console.log(router.currentRoute.path);
            if(router.currentRoute.path!="/project_addition")
              router.push({ path: '/project_addition' })
            else 
              componentBus.$emit('open_the_sidebar', true);
            //console.log("create project");
            break;
         case 4:
           //console.log(router.currentRoute.path);
            if(router.currentRoute.path!="/search_project_to_edit")
              router.push({ path: '/search_project_to_edit' })
            //console.log("edit project");
            break;
         case 5:
           //console.log(router.currentRoute.path);
            if(router.currentRoute.path!="/poi_manager")
              router.push({ path: '/poi_manager' })
            //console.log("poi manager");
            break;
         case 6:
           //console.log(router.currentRoute.path);
            if(router.currentRoute.path!="/search_project_to_create_poi")
              router.push({ path: '/search_project_to_create_poi' })
           // console.log("create poi");
            break;
         case 7:
           //console.log(router.currentRoute.path);
            if(router.currentRoute.path!="/search_poi_to_edit")
              router.push({ path: '/search_poi_to_edit' })
           // console.log("edit poi");
            break;
         case 8:
           //console.log(router.currentRoute.path);
            if(router.currentRoute.path!="/quiz_manager")
              router.push({ path: '/quiz_manager' })
            //console.log("quiz manager");
            break;
         case 9:
           //console.log(router.currentRoute.path);
            if(router.currentRoute.path!="/search_poi_to_create_quiz")
              router.push({ path: '/search_poi_to_create_quiz' })
            //console.log("create quiz");
            break;
          case 10:
            //console.log(router.currentRoute.path);
            if(router.currentRoute.path!="/search_poi_to_edit_quiz")
            router.push({ path: '/search_poi_to_edit_quiz' })
            //console.log("edit quiz");
            break;
          case 11:
            
            if(router.currentRoute.path!="/admin_console")
            router.push({ path: '/admin_console' });  
            else 
              componentBus.$emit('open_admin_sidebar', true);
            break;
         default:
    // code block
} 

    }
        //alert(evt[0].name);
      //alert("hey nick");
      //console.log(evt[0]);
     


},


     some_handler()
     {
      
      console.log("gia nick");


     },

     handleResize() {
      //this.window.width = window.innerWidth;
     // this.window.height = window.innerHeight;
     
    },


  


   
     
      none () {
      
        this.mini = !this.mini

      },
       
     
      

    
 },




 mounted() {
  
    this.leaflet_dom_util=  L.DomUtil;
    if (this.$keycloak.realmAccess.roles.includes('admin')) this.items.push(  {id:11, name: "Admin Console"}    );  

        // it is correct  this.active_node.push({id: 2});

   
       //  this.window.height=1000;
         //window.addEventListener('resize', this.handleResize);
         //this.handleResize();
        
         this.map = L.map('map', { zoomControl: false} ).setView([37.9838, 23.7275], 5).on('click', (e) => {
    //alert("Lat, Lon : " + e.latlng.lat + ", " + e.latlng.lng);
   // alert(this.pick_a_point);
    if(this.pick_a_point)
    {
        if(router.currentRoute.path=="/project_addition" || router.currentRoute.path=="/project_edit") 
        {
         if(this.temporary_pin!=null) this.map.removeLayer(this.temporary_pin);

         let m = L.marker([e.latlng.lat,e.latlng.lng],{icon: this.temporary_project_icon});
         this.map.addLayer( m );
         this.temporary_pin=m;
        
        
        //this.pins[project_payload.uuid]= m;
        }
        else if(router.currentRoute.path=="/poi_addition" || router.currentRoute.path=='/poi_edit') 
        {
         if(this.temporary_pin!=null) this.map.removeLayer(this.temporary_pin);

         let m = L.marker([e.latlng.lat,e.latlng.lng],{icon: this.temporary_poi_icon});
         this.map.addLayer( m );
         this.temporary_pin=m;
        
        
        //this.pins[project_payload.uuid]= m;
        }
            
    
    componentBus.$emit('selected_point_coordinates', e.latlng);
    //this.pick_a_point= false;
    }

});
         L.control.zoom({
                       position:'bottomright'
                       }).addTo(this.map);

          L.tileLayer(MAP_URL, {
                attribution: ATTRIBUTION,
                subdomains: ['a', 'b', 'c']
            })
            .addTo(this.map);

        //componentBus.$emit('poi_addition_update_navigation_bar', true);


          componentBus.$on('destroy_temporary_pin', (payload) => {
             console.log(payload);
            if(this.temporary_pin!=null)
            {
             this.map.removeLayer(this.temporary_pin);  
             this.temporary_pin=null;
            }
            });
8
        componentBus.$on('render_relevant_pois_and_range_and_focus_on_map', (payload) => {

              this.render_on_map_relevant_pois_and_project_range(payload["relevant_project"]).then(() => {
                 if (typeof this.pins[payload["point_uuid"]]!=='undefined')
                 {
                 // here to enlarge the pin
                 if(this.enlarged_pin!=null)
                 { 
                 this.leaflet_dom_util.removeClass(   this.enlarged_pin['pin']._icon, "blinking");
                 //*if(this.enlarged_pin['type']=='project') this.enlarged_pin['pin'].setIcon(this.project_icon);
                 //*else if(this.enlarged_pin['type']=='poi_without_quiz') this.enlarged_pin['pin'].setIcon(this.poi_without_quiz_icon);
                 //*else if(this.enlarged_pin['type']=='poi_with_quiz') this.enlarged_pin['pin'].setIcon(this.poi_with_quiz_icon);
                 }
                 this.enlarged_pin={};
                 this.enlarged_pin['type']='project';
                 this.enlarged_pin['pin']=this.pins[payload["point_uuid"]];
                 //*this.pins[payload["point_uuid"]].setIcon(this.project_icon_enlarged);
                 this.leaflet_dom_util.addClass(   this.enlarged_pin['pin']._icon, "blinking");

                  this.map.setView(this.pins[payload["point_uuid"]].getLatLng(),17);
                 }  
                else if(typeof this.pois_on_map_list['pois'][payload["point_uuid"]]!=='undefined')
                //here to enlarge the pin
                 {  
                 if(this.enlarged_pin!=null)
                 { 
                  this.leaflet_dom_util.removeClass(   this.enlarged_pin['pin']._icon, "blinking");
                 //*if(this.enlarged_pin['type']=='project') this.enlarged_pin['pin'].setIcon(this.project_icon);
                 //*else if(this.enlarged_pin['type']=='poi_without_quiz') this.enlarged_pin['pin'].setIcon(this.poi_without_quiz_icon);
                 //*else if(this.enlarged_pin['type']=='poi_with_quiz') this.enlarged_pin['pin'].setIcon(this.poi_with_quiz_icon);
                 }
                   this.enlarged_pin={};
                   this.pois_on_map_list['pois'][payload["point_uuid"]].options.icon.options.iconUrl=="PointofInterest2.svg" ? this.enlarged_pin['type']='poi_without_quiz' : this.enlarged_pin['type']='poi_with_quiz';
                   this.enlarged_pin['pin']=this.pois_on_map_list['pois'][payload["point_uuid"]]
                   //this.pois_on_map_list['pois'][payload["point_uuid"]].options.icon.options.iconUrl=="PointofInterest2.svg" ? this.pois_on_map_list['pois'][payload["point_uuid"]].setIcon(this.poi_without_quiz_icon_enlarged) : this.pois_on_map_list['pois'][payload["point_uuid"]].setIcon(this.poi_with_quiz_icon_enlarged);
                   this.leaflet_dom_util.addClass(    this.pois_on_map_list['pois'][payload["point_uuid"]]._icon, "blinking" );
                   // here to enlarge the pin
                    // centerMarker.setIcon(bigIcon);
                    //this.poi_with_quiz_icon
                    //poi_without_quiz_icon_enlarged
                  this.map.setView(this.pois_on_map_list['pois'][payload["point_uuid"]].getLatLng(),17); 
                 }
               
              })
               .catch(err => console.log("Axios err: ", err))

              

              //if(parameter.length==1)
              // {   typeof this.pois_on_map_list !== 'undefined' && typeof this.pois_on_map_list['pois'] !== 'undefined'
              //  console.log(this.pins[parameter[0]].getLatLng());
                //render_on_map_relevant_pois_and_project_range(project_uuid)

                         

             //  }
             //  else
             //  {
           //   this.map.setView(parameter,17);
            //  console.log("lat_long_list:  "+parameter);
            //   }       
            });

            componentBus.$on('focus_on_pin', (payload) => {
            //.  if(payload["type"]=="project" && typeof this.pins[payload['point_uuid']] !=='undefined')
             //   {
                  // here to enlarge the pin
                if(this.enlarged_pin!=null)
                 { 
                 this.leaflet_dom_util.removeClass(   this.enlarged_pin['pin']._icon, "blinking");
                 //*if(this.enlarged_pin['type']=='project') this.enlarged_pin['pin'].setIcon(this.project_icon);
                 //*else if(this.enlarged_pin['type']=='poi_without_quiz') this.enlarged_pin['pin'].setIcon(this.poi_without_quiz_icon);
                 //*else if(this.enlarged_pin['type']=='poi_with_quiz') this.enlarged_pin['pin'].setIcon(this.poi_with_quiz_icon);
                 }
                 this.enlarged_pin={};
                 this.enlarged_pin['type']='project';
                 this.enlarged_pin['pin']=this.pins[payload["point_uuid"]];
                 this.leaflet_dom_util.addClass(   this.pins[payload["point_uuid"]]._icon, "blinking");
                 //*this.pins[payload["point_uuid"]].setIcon(this.project_icon_enlarged);
                 this.map.setView(this.pins[payload["point_uuid"]].getLatLng(),17); 
             //   }   
            //.  else if(payload["type"]=="poi" && typeof this.pois_on_map_list['pois'][payload['point_uuid']]!=='undefined')
                  // here to enlarge the pin
                //.  {
               //.   if(this.enlarged_pin!=null)
               //.  { 
                //.   console.log("hello one");
                 //.  console.log("hello two");
              //.   this.leaflet_dom_util.removeClass(   this.enlarged_pin['pin']._icon, "blinking");
                 //*if(this.enlarged_pin['type']=='project') this.enlarged_pin['pin'].setIcon(this.project_icon);
                 //*else if(this.enlarged_pin['type']=='poi_without_quiz') this.enlarged_pin['pin'].setIcon(this.poi_without_quiz_icon);
                 //*else if(this.enlarged_pin['type']=='poi_with_quiz') this.enlarged_pin['pin'].setIcon(this.poi_with_quiz_icon);
               //.  }
                  //. this.enlarged_pin={};
                 //.  this.pois_on_map_list['pois'][payload["point_uuid"]].options.icon.options.iconUrl=="PointofInterest2.svg" ? this.enlarged_pin['type']='poi_without_quiz' : this.enlarged_pin['type']='poi_with_quiz';
                  //. this.enlarged_pin['pin']=this.pois_on_map_list['pois'][payload["point_uuid"]]
                   //*this.pois_on_map_list['pois'][payload["point_uuid"]].options.icon.options.iconUrl=="PointofInterest2.svg" ? this.pois_on_map_list['pois'][payload["point_uuid"]].setIcon(this.poi_without_quiz_icon_enlarged) : this.pois_on_map_list['pois'][payload["point_uuid"]].setIcon(this.poi_with_quiz_icon_enlarged);
                  //. this.leaflet_dom_util.addClass(  this.enlarged_pin['pin']._icon, "blinking");

                //.  this.map.setView(this.pois_on_map_list['pois'][payload["point_uuid"]].getLatLng(),17);
                //.  }
                               
            });




        componentBus.$on('deleted_project', (project_uuid) => {
          
              
                  let project= this.pins[project_uuid];
                  this.map.removeLayer(project);  

                  //let circle= this.circles[project_uuid];   because we removed circles form projects
				  //this.map.removeLayer(circle);
				  
                  //this.active_node.splice(0,this.active_node.length);
                  //this.active_node.push({id: 2});

                  this.delete_relevant_pois(project_uuid);
                   this.enlarged_pin=null;
              

                  router.push({ path: '/' }); 


                  // have to continue with pois...
                
                
              
            });



        componentBus.$on('deleted_poi', (poi_uuid) => {
          
              
                  //let poi= this.pins[poi_uuid];
                  let poi= this.pois_on_map_list['pois'][poi_uuid]
				  this.map.removeLayer(poi);  
				  
				  let circle= this.circles[poi_uuid];   
				  this.map.removeLayer(circle);
				  delete this.circles;
		          this.circles=null;

                  this.enlarged_pin=null;
                  //this.active_node.splice(0,this.active_node.length);
                  //this.active_node.push({id: 2});

                 

                  //router.push({ path: '/' }); 


               
                
                
              
            });
            
    
            componentBus.$on('poi_to_remove_quiz', (poi_uuid) => {
          
                  let poi= this.pois_on_map_list['pois'][poi_uuid];

                  //let poi= this.pins[poi_uuid];
                  this.map.removeLayer(poi);  
                  delete this.pois_on_map_list['pois'][poi_uuid];
                  this.enlarged_pin=null;
                  //delete this.pins[poi_uuid];
                  //this.fetch_poi_details(poi_uuid);
                  this.update_the_poi_icon_for_removing_quiz(poi_uuid);
             
              
            });






        componentBus.$on('poi_addition_update_navigation_bar', (update) => {
               if(update) 
                {
                 console.log(update);
                 //it is correct  this.active_node.splice(0,this.active_node.length);
                 //it is correct  this.active_node.push({id: 6});
                }
                    
                
                
              
            });


         componentBus.$on('quiz_addition_update_navigation_bar', (update) => {
               if(update) 
                {
                 console.log(update);
                 //it is correct  this.active_node.splice(0,this.active_node.length);
                 //it is correct  this.active_node.push({id: 9});
                }
                    
                
                
              
            });
         
          componentBus.$on('quiz_edit_update_navigation_bar', (update) => {
               if(update) 
                {
                 console.log(update);
                 //it is correct  this.active_node.splice(0,this.active_node.length);
                 // it is correct  this.active_node.push({id: 10});
                }
                    
                
                
              
            });
        
        

        componentBus.$on('updated_project_payload', (payload) => {
                let pin_to_be_updated= this.pins[payload["project_uuid"]];
                let previous_longitude= pin_to_be_updated.getLatLng().lng;
                let previous_latitude= pin_to_be_updated.getLatLng().lat;
                let new_longitude= payload["point"]["coordinates"][0];
                let new_latitude= payload["point"]["coordinates"][1];
                if(previous_longitude!= new_longitude || previous_latitude!=new_latitude  )
                  {
                  //alert("alakse i topothesia");
                  var newLatLng = new L.LatLng(new_latitude, new_longitude);
                  pin_to_be_updated.setLatLng(newLatLng); 
                 

				  }  
				  
				  /*   because we removed circles from projects.
                  let old_circle= this.circles[payload["project_uuid"]];
                  this.map.removeLayer(old_circle); 
                  delete this.circles[payload["project_uuid"]];
                  
                  let new_circle = L.circle([new_latitude, new_longitude], {
                        color: 'red',
                        fillColor: '#f03',
                        fillOpacity: 0.2,
                        radius: payload["range"],
                        interactive: false
                        });
                  this.map.addLayer(new_circle);
                  this.circles[payload["project_uuid"]]= new_circle; 
                */ 
                
                
              
            });

         componentBus.$on('updated_poi_payload', (payload) => {
			   
                let pin_to_be_updated= this.pois_on_map_list['pois'][payload["poi_uuid"]]
                //let pin_to_be_updated= this.pins[payload["poi_uuid"]];
                let previous_longitude= pin_to_be_updated.getLatLng().lng;
                let previous_latitude= pin_to_be_updated.getLatLng().lat;
                let new_longitude= payload["point"]["coordinates"][0];
				let new_latitude= payload["point"]["coordinates"][1];
				
                if(previous_longitude!= new_longitude || previous_latitude!=new_latitude  )
                  {
                  //alert("alakse i topothesia");
                  var newLatLng = new L.LatLng(new_latitude, new_longitude);
                  pin_to_be_updated.setLatLng(newLatLng); 
                 

				  }  
				
				  let old_circle= this.circles[payload["poi_uuid"]];
                  this.map.removeLayer(old_circle); 
                  delete this.circles[payload["poi_uuid"]];
                  
                  let new_circle = L.circle([new_latitude, new_longitude], {
                        color: 'red',
                        fillColor: '#f03',
                        fillOpacity: 0.2,
                        radius: payload["activation_range"],
                        interactive: false
                        });
				  this.map.addLayer(new_circle);
				  this.circles={};
                  this.circles[payload["poi_uuid"]]= new_circle; 

                 
                
                    
                
                
              
            });    



        componentBus.$on('pick_a_point', (pick_a_point) => {
				//this.pick_a_point=pick_a_point;
				this.pick_a_point=true;

                //this.open_nodes.splice(0,this.open_nodes.length);

                
              //  perfectly works....   this.active_node.splice(0,this.active_node.length);

              //  perfectly works ... this.active_node.push({ id: 1 });

                 
                //this.open_nodes.push(7);
                //delete this.active_node[0];
                //this.active_node[0]=1;
                //console.log(this.active_node);
                //this.active_node.splice(0,this.active_node.length);
                //this.active_node.push(2);
                 //this.active_node.splice(0,this.active_node.length);
                  //this.active_node.push(1);

               // this.active_node[0]=1;

                //console.log(this.active_node);
                //this.active_node.push(1);
                //this.active_node=[1];
                //console.log(this.active_node);
                //console.log(this.selected_items);
                
              
			});
		componentBus.$on('stop_picking_point', (parameter) => {
				
				this.pick_a_point=false;

                
                
              
            });
        componentBus.$on('newly_created_project', (project_payload) => {
               
       
        
        let m=  new this.custom_marker([project_payload.point.coordinates[1],project_payload.point.coordinates[0]], {icon: this.project_icon, uuid: project_payload.uuid, type: "project", name: project_payload.title}).on('click', (e) => {
               console.log("newly created project   "+e.target.getLatLng());
               this.render_on_map_relevant_pois_and_project_range(project_payload.uuid);

               if(router.currentRoute.path!="/project_edit") 
                {
                router.push({ path: '/project_edit', query: { uuid: project_payload.uuid }});
                }
               else
               componentBus.$emit('project_to_edit_uuid', project_payload.uuid);

        });
              
               // na ksanampei  this.pins.push( m );
               this.pins[project_payload.uuid]= m;
               this.map.addLayer( m );

               //this.map.setView(project_payload.point.coordinates.reverse(),17);
                this.render_on_map_relevant_pois_and_project_range(project_payload.uuid);
                router.push({ path: '/project_edit', query: { uuid: project_payload.uuid }});

            });  // end of newly created_project listener

        componentBus.$on('newly_created_poi', (poi_payload) => {
               

        let m=  new this.custom_marker([poi_payload.point.coordinates[1],poi_payload.point.coordinates[0]], {icon: this.poi_without_quiz_icon, uuid: poi_payload.uuid, type: "poi", name: poi_payload.title}).on('click', (e) => {
						  console.log(e);
						 
						  if ( this.circles !== null) 
                          {
                          Object.values(this.circles).forEach(circle => {
                          this.map.removeLayer(circle); 
                          });  
                          }
                          delete this.circles;
						  this.circles=null;
						  let circle = L.circle([poi_payload.point.coordinates[1],poi_payload.point.coordinates[0] ], {
                          color: 'red',
                          fillColor: '#f03',
                          fillOpacity: 0.2,
                          radius: poi_payload["activation_range"],
                          interactive: false,
						   }).addTo(this.map);
						  this.circles={};
						  this.circles[poi_payload.uuid]= circle;
						  
						if(this.enlarged_pin!=null)
                       { 
                       this.leaflet_dom_util.removeClass(this.enlarged_pin['pin']._icon, "blinking");
                       //*if(this.enlarged_pin['type']=='project') this.enlarged_pin['pin'].setIcon(this.project_icon);
                       //*else if(this.enlarged_pin['type']=='poi_without_quiz') this.enlarged_pin['pin'].setIcon(this.poi_without_quiz_icon);
                       //*else if(this.enlarged_pin['type']=='poi_with_quiz') this.enlarged_pin['pin'].setIcon(this.poi_with_quiz_icon);
                       }
                       this.enlarged_pin={};
                       this.enlarged_pin['type']='poi_without_quiz';
                       this.enlarged_pin['pin']=this.pois_on_map_list['pois'][poi_payload.uuid]
                       //*this.pois_on_map_list['pois'][poi_payload.uuid].setIcon(this.poi_without_quiz_icon_enlarged)
                       this.leaflet_dom_util.addClass(   this.pois_on_map_list['pois'][poi_payload.uuid]._icon, "blinking");

                  
                        //this.map.setView(poi_payload.point.coordinates.reverse(),17);


                         //this.map.setView(e.target.getLatLng(),17);
                         // it is correct  this.active_node.splice(0,this.active_node.length);
                         // it is correct  this.active_node.push({id: 7});
                                 
                         if(router.currentRoute.path!="/poi_edit") 
                            {
                              router.push({ path: '/poi_edit', query: { poi_uuid: poi_payload.uuid, project_uuid: poi_payload.relevant_project }});
                             
                             }
                            else
                            componentBus.$emit('poi_to_edit_uuid', poi_payload.uuid);
						  
						  
					
                          
                            });

 
                                   
                          

                        // na ksanampei  this.pins.push( m );
                        this.pois_on_map_list['pois'][poi_payload.uuid]=m;
                        //this.pins[poi_payload.uuid]= m;
                        this.map.addLayer( m );
                        // enlarge the pin here

                      
                        //this.active_node.splice(0,this.active_node.length);
                        //this.active_node.push({id: 2});

            });


        componentBus.$on('newly_created_quiz', (quiz_payload) => {
           
           let poi= this.pois_on_map_list['pois'][quiz_payload.relevant_poi];
           //let poi= this.pins[quiz_payload.relevant_poi];
		   this.map.removeLayer(poi);  
		   delete this.pois_on_map_list['pois'][quiz_payload.relevant_poi];
           //delete this.pins[quiz_payload.relevant_poi];
          // this.fetch_poi_details(quiz_payload.relevant_poi);   
           var get_poi_url=APIS_BASE_URL+"/pois/"+quiz_payload.relevant_poi+"/";
           var get_poi_url_encoded= encodeURI(get_poi_url);
   
           axios.get(get_poi_url_encoded)
                    .then(response => {
                   

                    let m=  new this.custom_marker([response.data.point.coordinates[1],response.data.point.coordinates[0]], {icon: this.poi_with_quiz_icon, uuid: quiz_payload.relevant_poi, type: "poi", name: response.data.title}).on('click', (e) => {
					 console.log(e);
					 if ( this.circles !== null) 
                      {
                      Object.values(this.circles).forEach(circle => {
                      this.map.removeLayer(circle); 
                      });  
                      }
                      delete this.circles;
					  this.circles=null;
					  let circle = L.circle([response.data.point.coordinates[1],response.data.point.coordinates[0] ], {
                      color: 'red',
                      fillColor: '#f03',
                      fillOpacity: 0.2,
                      radius: quiz_payload.range,
                      interactive: false,
					   }).addTo(this.map);
					  this.circles={};
                      this.circles[quiz_payload.relevant_poi]= circle;

					  if(this.enlarged_pin!=null) this.leaflet_dom_util.removeClass(this.enlarged_pin['pin']._icon, "blinking");
                       
                       this.enlarged_pin={};
                       this.enlarged_pin['type']='poi_with_quiz';
                       this.enlarged_pin['pin']=this.pois_on_map_list['pois'][quiz_payload.relevant_poi];
                      
                       this.leaflet_dom_util.addClass(   this.pois_on_map_list['pois'][quiz_payload.relevant_poi]._icon, "blinking");
                     //this.map.setView(e.target.getLatLng(),17);
                         //it is correct   this.active_node.splice(0,this.active_node.length);
                         //it is correct  this.active_node.push({id: 7});
                                 
                         if(router.currentRoute.path!="/poi_edit") 
                            {
                             router.push({ path: '/poi_edit', query: { poi_uuid: quiz_payload.relevant_poi, project_uuid: quiz_payload.relevant_project }});
                             
                             }
                            else
                            componentBus.$emit('poi_to_edit_uuid', quiz_payload.relevant_poi);
                          
                          
                            });

 
                                   
                          

                        this.pois_on_map_list['pois'][quiz_payload.relevant_poi]= m;
                        //this.pins[quiz_payload.relevant_poi]= m;
                        this.map.addLayer( m );
                        // enlarge the pin here
                       //if(this.enlarged_pin!=null)
                       //{ 
                      // this.leaflet_dom_util.removeClass(this.enlarged_pin['pin']._icon, "blinking");
                       //*if(this.enlarged_pin['type']=='project') this.enlarged_pin['pin'].setIcon(this.project_icon);
                       //*else if(this.enlarged_pin['type']=='poi_without_quiz') this.enlarged_pin['pin'].setIcon(this.poi_without_quiz_icon);
                       //*else if(this.enlarged_pin['type']=='poi_with_quiz') this.enlarged_pin['pin'].setIcon(this.poi_with_quiz_icon);
                      // }
					   if(quiz_payload.focus_on_pin) {
                       this.enlarged_pin={};
                       this.enlarged_pin['type']='poi_with_quiz';
                       this.enlarged_pin['pin']=this.pois_on_map_list['pois'][quiz_payload.relevant_poi];
                       this.leaflet_dom_util.addClass( this.pois_on_map_list['pois'][quiz_payload.relevant_poi]._icon, "blinking");
                       //*this.pois_on_map_list['pois'][quiz_payload.relevant_poi].setIcon(this.poi_with_quiz_icon_enlarged)
                        this.map.setView(response.data.point.coordinates.reverse(),17);
					}
                        //this.active_node.splice(0,this.active_node.length);
                        //this.active_node.push({id: 2});

                   
                    
                        
                    })
                    .catch(error => console.log(error));

           
           
           
           
        

            });





         var url_query=APIS_BASE_URL+"/map_rendering/";
         var my_url= encodeURI(url_query);
   
         axios.get(my_url)
              .then(response => {
                  response.data
                    .forEach(val => {
                      var entry = {
                       entity_uuid: val.project_uuid,
                       type: "project",
                       title: val.title,
                       longitude: val.point.coordinates[0],
                       latitude: val.point.coordinates[1],
                       pois: val.relevant_pois,   // this to be removed, not necessary to be brought by the backend
                       //range: val.range
                        };


                        
                        let m=  new this.custom_marker([entry.latitude,entry.longitude], {icon: this.project_icon, uuid: entry.entity_uuid, type: "project", name: entry.title}).on('click', (e) => {
                          console.log(e);
                        this.render_on_map_relevant_pois_and_project_range(entry.entity_uuid);

                         
                        
                          
                            // it is correct  this.active_node.splice(0,this.active_node.length);
                            // it is correct  this.active_node.push({id: 4});
                            //this.map.setView(e.target.getLatLng(),17);
                                  
                            //if(router.currentRoute.path=="/project_edit/"+entry.entity_uuid) router.replace({ path: 'project_edit', query: { uuid: entry.entity_uuid } });
                              //else 
                             //router.push({ path: 'project_edit', query: { uuid: entry.entity_uuid } });    
                             
                            

                            if(router.currentRoute.path!="/project_edit") 
                             {
                              //alert(entry.entity_uuid);
                              //componentBus.$emit('project_to_edit_uuid', entry.entity_uuid);
                              router.push({ path: '/project_edit', query: { uuid: entry.entity_uuid }});
                             
                             }
                            else
                            componentBus.$emit('project_to_edit_uuid', entry.entity_uuid);
                            
                            //this.map.setView(e.target.getLatLng(),10);
                            //alert("ola kala?");
                            });   //end of project click
                        this.pins[entry.entity_uuid]= m;
                        //this.pins.push( m );
                        this.map.addLayer( m );
                        
                        //let circle = L.circle([entry.latitude, entry.longitude], {
                        //color: 'red',
                        //fillColor: '#f03',
                        //fillOpacity: 0.2,
                        //radius: entry.range,
                        //interactive: false
                       // }).addTo(this.map);
                        //this.circles[entry.entity_uuid]= circle;
                        //console.log(circle);
                        
                        });  // end of projects loop

                       

                        // now add pois * will not add pois from the start
                        /*
                        entry.pois
                          .forEach(poi => {
                            let relevant_quiz= poi.relevant_quiz;
                            let poi_icon= relevant_quiz.length > 0 ? this.poi_with_quiz_icon : this.poi_without_quiz_icon;
                            let m=  new this.custom_marker([poi.point.coordinates[1],poi.point.coordinates[0]], {icon: poi_icon, uuid: poi.poi_uuid, type: "poi", name: poi.title}).on('click', (e) => {
                            console.log(e);
                              
                                   
                             if(router.currentRoute.path!="/poi_edit") 
                             {
                             
                              router.push({ path: '/poi_edit', query: { uuid: poi.poi_uuid }});
                              console.log("parto malaka: "+ poi.poi_uuid);

                             
                             }
                            else
                            componentBus.$emit('poi_to_edit_uuid', poi.poi_uuid);
                            
                                  
                                  console.log(e);
                          
                            });
                            this.pins[poi.poi_uuid]=m;
                  
                            this.map.addLayer( m );


                            


                          });
                         */

                     // check in case someone passes a URL without interacting with the interface.
                     if(router.currentRoute.path=="/poi_edit")   
                      {
                       let poi_uuid= this.$route.query.poi_uuid;
                       this.fetch_poi_details_and_render_on_map(poi_uuid);
                      }
                      else if(router.currentRoute.path=="/project_edit")   
                      {
                         let project_uuid= this.$route.query.uuid;
                         console.log(project_uuid);

                         this.render_on_map_relevant_pois_and_project_range(project_uuid).then(() => {
                         this.map.setView(this.pins[project_uuid].getLatLng(),17);  
                        
               
                        })
                        .catch(err => console.log("Axios err: ", err))
                        }
                      else if(router.currentRoute.path=="/poi_addition")   
                      {
                         let project_uuid= this.$route.query.project_uuid;
                         console.log(project_uuid);

                         this.render_on_map_relevant_pois_and_project_range(project_uuid).then(() => {
                         this.map.setView(this.pins[project_uuid].getLatLng(),17);  
                        
               
                        })
                        .catch(err => console.log("Axios err: ", err))
                        }
                       else if(router.currentRoute.path=="/quiz_addition")   
                      {
                         let poi_uuid= this.$route.query.poi_uuid;
                         console.log(poi_uuid);
                         this.fetch_poi_details_and_render_on_map(poi_uuid);

                        
                        }
                      else if(router.currentRoute.path=="/quiz_edit")   
                      {
                         let quiz_uuid= this.$route.query.quiz_uuid;
                         console.log(quiz_uuid);
                         this.fetch_quiz_details_and_render_on_map(quiz_uuid);

                        
                      }
                        //console.log(this.pins);
                    })  // end of response
                    .catch(error => console.log(error));
           



  





           

       
             


},
destroyed() {
   // window.removeEventListener('resize', this.handleResize)
   componentBus.$off('pick_a_point');
   componentBus.$off('stop_picking_point');
   componentBus.$off('newly_created_project');
   componentBus.$off('newly_created_poi');
   componentBus.$off('newly_created_quiz');
   componentBus.$off('deleted_project');
   componentBus.$off('deleted_poi');
   componentBus.$off('poi_addition_update_navigation_bar');
   componentBus.$off('quiz_addition_update_navigation_bar');
   componentBus.$off('updated_project_payload');
   componentBus.$off('updated_poi_payload');
   componentBus.$off('poi_to_remove_quiz');
   componentBus.$off('render_relevant_pois_and_range_and_focus_on_map');
   componentBus.$off('destroy_temporary_pin');
   componentBus.$off('focus_on_pin');
   

   
  
   
  },

 

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>


@import "../../node_modules/leaflet/dist/leaflet.css";


/*
.clock {
  width: 500px;
  text-align: center;
  position: absolute;
  
  
 
}
*/
.small_left_margin {
  margin-left: 90px;

   

}

.big_left_margin {
  margin-left: 265px;

   

}

.crosshair_cursor {
  cursor: crosshair !important;
}

.simple_cursor {
  cursor: '' !important;
}



    #map {
        width: 100%;
        height: 850px;
        z-index: 0;
        
       
    }


.clock {
  /*
  width: 200px;
  */
  position: absolute;
  
  
 
}
.legend {
  padding: 6px 8px;
  font: 14px Arial, Helvetica, sans-serif;
  background: white;
  background: rgba(255, 255, 255, 0.8);
  /*box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);*/
  /*border-radius: 5px;*/
  line-height: 24px;
  color: #555;
}
.legend h4 {
  text-align: left;
  font-size: 16px;
  margin: 2px 12px 8px;
  color: #777;
}

.legend span {
  position: relative;
  bottom: 3px;
}

.legend img {
 
  float: left;
  margin: 0 8px 0 0;
  opacity: 0.7;
}

.legend i.icon {
  background-size: 18px;
  background-color: rgba(255, 255, 255, 1);
}

#search_element {

 position: fixed;
 bottom: 0;
 margin-bottom: 50px;
 width: 850px;


}

@keyframes fade { 
  from { opacity: 0.1; } 
}

.blinking {
  animation: fade 0.5s infinite alternate;
}

.temporary_pin
{
 opacity: 0.4;


}
</style>
